import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import NotificationBannerHost from "./components/NotificationBanner";
import TosGate from "./components/TosGate";
import BagelChat from "./components/BagelChat";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <NotificationBannerHost />
          <AppRoutes />
          <TosGate />
          <BagelChat />
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
